const { createSlice } = require("@reduxjs/toolkit");

const allCategoriesSlice = createSlice({
  name: "allCategories",
  initialState: {
    allCategories: [],
    allCollectionList: [],
  },
  reducers: {
    setallCategories(state, action) {
      state.allCategories = action.payload;
    },
    setallCollectionList(state, action) {
      state.allCollectionList = action.payload;
    },
  },
});

export const { setallCategories, setallCollectionList } =
  allCategoriesSlice.actions;
export default allCategoriesSlice.reducer;
